import InboxIcon from '@mui/icons-material/InboxOutlined'
import type React from 'react'

import * as S from './styles'

export interface EmptyStateProps {
  /** Icon shown inside the chip; defaults to an inbox */
  icon?: React.ReactNode
  title: React.ReactNode
  /** One short line explaining what will appear here */
  hint?: React.ReactNode
  /** Suggested next action (usually a small outlined Button) */
  action?: React.ReactNode
  compact?: boolean
  /** Fill and vertically centre in a parent that reserves its height. */
  fullHeight?: boolean
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  hint,
  action,
  compact,
  fullHeight,
}) => (
  <S.Root compact={compact} fullHeight={fullHeight}>
    <S.IconChip>{icon ?? <InboxIcon />}</S.IconChip>
    <S.Title>{title}</S.Title>
    {hint && <S.Hint>{hint}</S.Hint>}
    {action}
  </S.Root>
)

EmptyState.displayName = 'EmptyState'
export default EmptyState
